import { IWeekSchedule, ICmsRoute } from "./CMS";

export enum Locality { Domestic, International }

export interface IRoute {
    origin?: string;
    destination?: string;
    locality?: Locality;
    weekSchedule?: IWeekSchedule;
    bookingProvider?: string;
    path?: string;
    availableForIB?: boolean;
}

export const mapCmsRouteToRoute = (r: ICmsRoute): IRoute => {
    const [origin, destination] = r.code?.code.split("-") || [];
    const route: IRoute = {
        origin,
        destination,
        locality: r.locality === "I" ? Locality.International : Locality.Domestic,
        bookingProvider: r.bookingProvider,
        weekSchedule: r.weekSchedule,
        path: r.path,
        availableForIB: r.availableForIB
    };
    return route;
}